import React from 'react'

import cn from 'classnames'

import { BodyText, MetaText } from 'components/Typography'

import styles from './DropDownItem.module.scss'
import { DropDownItemProps } from './types'
import BaseDropDownItem from '../BaseDropDownItem/BaseDropDownItem'

const DropDownItem: React.FC<DropDownItemProps> = ({
  iconElement,
  label,
  metaText,
  shouldFillIcon = true,
  ...props
}) => {
  return (
    <BaseDropDownItem {...props}>
      <div className={styles.label}>
        {iconElement && (
          <span className={cn(styles.iconWrapper, shouldFillIcon && styles.iconFill)}>
            {iconElement}
          </span>
        )}
        <BodyText hasEllipsis>{label}</BodyText>
      </div>
      {metaText && <MetaText className={styles.metaText}>{metaText}</MetaText>}
    </BaseDropDownItem>
  )
}

export default DropDownItem
